import React from "react";
import DotsComponent from "../../DotsComponent";

export const ReqProTable = ({props,heading,title})=>{
    console.log("req" , props)
    return(
      // className="hrChildRight" id="hr-div-child2-right"
      <div>
        <DotsComponent/>
        <div className="reqprotable">
        <h3 style={{fontWeight:'500', marginTop:'12px'}}>{title.map((val)=>val.name)}</h3>
        <table className="th-light" width={'100%'}>
          <tr>
          {heading.map((val)=>(
             <th>{val.heading}</th>
            ))}
          </tr>
          {props.map((val) => (
            <tr>
              <td >{val.fname}</td>
              <td>{val.profession}</td>
              <td>{val.status}</td>
            </tr>
          ))}
        </table>
      </div> 
      </div>
    );
}
